'use client'

import React, { JSX } from 'react'
import createWidget, { IPageDataContext } from '@/widgets/create-widget'
import { PhotoIcon } from '@heroicons/react/24/solid'
import GoalSelection from '@/components/RevampedLanding/GoalSelection'
import GoalSelectionSchema, { GoalSelectionDefaultValues, GoalSelectionProps } from './schema'
import { HeroSectionDefaultValues } from '../hero-section/schema'

export function GoalSelectionWidget({ pageData }: IPageDataContext) {
  return (
    <GoalSelection
      goalsData={pageData?.curiousJrLandingData?.data?.goalSection}
      appRedirectionScreen={pageData?.curiousJrLandingData?.data?.appRedirectionScreen as any}
      isOtplessEnabled={!!pageData?.curiousJrLandingData?.data?.isOtplessEnabled}
    />
  )
}

export default createWidget({
  formType: {},
  render(props, pageData): JSX.Element {
    return <GoalSelectionWidget {...props} pageData={pageData} />
  },
  id: 'Landing.Page.Goal.Selection',
  name: 'Landing Goal Selection',
  icon: <PhotoIcon className='w-10 h-10' />,
  defaultProps: {},
})
